import React, {Component} from 'react';
import './MainSite.css';

import MainTitle from './MainTitle/MainTitle';
import Industries from './Industries/Industries';
import AboutUs from './AboutUs/AboutUs';
import TheTeam from './TheTeam/TheTeam';

class MainSite extends Component {
	render() {
		return (
			<main className="main_container">
				<MainTitle />
				<Industries />
				<AboutUs />
				<TheTeam />
			</main>
		);
	}
}

export default MainSite;
